import { useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { eur } from "@/lib/api";

export const CartDrawer = () => {
  const { items, open, setOpen, setQty, total } = useCart();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="w-full sm:max-w-md bg-[#FBFBFB] border-l border-[#0F0F0F] rounded-none p-0 flex flex-col">
        <div className="p-6 border-b border-[#0F0F0F]">
          <span className="tag text-[#555]">Il tuo carrello</span>
          <SheetTitle className="font-display font-black text-3xl tracking-tight mt-1">Carrello</SheetTitle>
          <SheetDescription className="sr-only">Prodotti nel carrello</SheetDescription>
        </div>
        <div className="flex-1 overflow-y-auto divide-y divide-[#0F0F0F]">
          {items.length === 0 && <p className="p-6 text-[#555]" data-testid="cart-empty">Il carrello è vuoto.</p>}
          {items.map((i) => (
            <div key={i.id} className="p-4 flex gap-4" data-testid={`cart-item-${i.id}`}>
              <img src={i.image} alt={i.title} className="w-20 h-20 object-cover border border-[#0F0F0F]" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium line-clamp-2">{i.title}</p>
                <p className="font-mono text-sm mt-1">{eur(i.price)}</p>
                <div className="flex items-center mt-2 border border-[#0F0F0F] w-fit">
                  <button data-testid={`cart-dec-${i.id}`} onClick={() => setQty(i.id, i.qty - 1)} className="p-1.5 hover:bg-[#0F0F0F] hover:text-white"><Minus size={14} /></button>
                  <span className="font-mono text-sm px-3" data-testid={`cart-qty-${i.id}`}>{i.qty}</span>
                  <button data-testid={`cart-inc-${i.id}`} onClick={() => setQty(i.id, i.qty + 1)} className="p-1.5 hover:bg-[#0F0F0F] hover:text-white"><Plus size={14} /></button>
                </div>
              </div>
              <button data-testid={`cart-remove-${i.id}`} onClick={() => setQty(i.id, 0)} className="self-start hover:text-[#FF3333]"><X size={18} /></button>
            </div>
          ))}
        </div>
        <div className="p-6 border-t border-[#0F0F0F] space-y-4">
          <div className="flex items-end justify-between">
            <span className="tag">Totale</span>
            <span className="font-display font-black text-4xl tracking-tight" data-testid="cart-total">{eur(total)}</span>
          </div>
          <p className="text-xs text-[#555]">Spedizione gratuita. Consegna diretta a casa tua.</p>
          <button
            data-testid="cart-checkout-button"
            disabled={!items.length}
            onClick={() => { setOpen(false); nav("/checkout"); }}
            className="btn-primary w-full h-12 font-medium"
          >
            Procedi all'ordine
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
